import { SelectOption } from '@web-for-marketing/react-ui';

const industryOptions: SelectOption[] = [
    { content: 'Accommodations, Leisure, and Recreation', value: 'Accommodations, Leisure, and Recreation' },
    { content: 'Construction and Specialty Trades', value: 'Construction and Specialty Trades' },
    { content: 'Educational Services', value: 'Educational Services' },
    { content: 'Finance, Real Estate, Rental, and Insurance', value: 'Finance, Real Estate, Rental, and Insurance' },
    { content: 'Health Care and Social Assistance', value: 'Health Care and Social Assistance' },
    { content: 'Manufacturing, Retail and Wholesale Trade', value: 'Manufacturing, Retail and Wholesale Trade' },
    { content: 'Media, Entertainment, and Technology', value: 'Media, Entertainment, and Technology' },
    {
        content: 'Natural Resources, Agriculture, and Utilities',
        value: 'Natural Resources, Agriculture, and Utilities',
    },
    {
        content: 'Professional, Administrative, and Consumer Services',
        value: 'Professional, Administrative, and Consumer Services',
    },
    { content: 'Public Administration and Waste Management', value: 'Public Administration and Waste Management' },
    { content: 'Transportation and Warehousing', value: 'Transportation and Warehousing' },
].sort((a, b) => a.content.localeCompare(b.content));

export default industryOptions;
